import { Component } from 'react'
import exceptionReporter from '@aytm/lib/common/exception-reporter'

function shallowEqual(a, b) {
  if (a !== b) {
    if (null != a && null != b && 'object' == typeof a && 'object' == typeof b) {
      for (const i in a) if (a[i] !== b[i]) return false
      for (const i in b) if (!(i in a)) return false
    } else return false
  }
  return true
}

export default class PureComponent extends Component {
  constructor(props, context) {
    super(props, context)
    this.mounted = false
    this.saveRef = this.saveRef.bind(this)
  }
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { props, state, context } = this
    return !shallowEqual(props, nextProps) || !shallowEqual(state, nextState) || !shallowEqual(context, nextContext)
  }
  setState(...args) {
    if (this.mounted) {
      super.setState(...args)
    }
  }
  UNSAFE_componentWillMount() {
    this.mounted = true
  }
  componentDidMount() {}
  componentWillUnmount() {
    this.mounted = false
  }
  UNSAFE_componentWillReceiveProps(/*nextProps, nextContext*/) {}
  UNSAFE_componentWillUpdate(/*nextProps, nextState, nextContext*/) {}
  componentDidUpdate(/*prevProps, prevState, prevContext*/) {}
  saveRef(name) {
    return (
      this[`saveRef${name}`] ||
      (this[`saveRef${name}`] = component => {
        this[`ref${name}`] = component
      })
    )
  }
  componentDidCatch(error, info) {
    exceptionReporter(error, 'common', info)
  }
}

// skip comparing function values
function shallowDataEqual(a, b) {
  if (a !== b) {
    if (null != a && null != b && 'object' == typeof a && 'object' == typeof b) {
      for (const i in a) {
        if ('function' == typeof a[i]) continue
        if (a[i] !== b[i]) return false
      }
      for (const i in b) {
        if ('function' == typeof b[i]) continue
        if (!(i in a)) return false
      }
    } else return false
  }
  return true
}

export class PureDataComponent extends PureComponent {
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { props, state, context } = this
    return (
      !shallowDataEqual(props, nextProps) ||
      !shallowDataEqual(state, nextState) ||
      !shallowDataEqual(context, nextContext)
    )
  }
}
